import React from "react";
import styled from "styled-components";
import { Colors } from "../../../../utils/colors/colors";



type IProps = {
  question: string;
  answer: string;
  id: number;
  activeFAQID: number;
  setActiveFAQID: React.Dispatch<React.SetStateAction<number>>;
  handleActiveFAQ: (id: number) => void;
}


const FAQItems = ({
  question,
  answer,
  id,
  activeFAQID,
  setActiveFAQID,
  handleActiveFAQ,
}: IProps) => {


  const { whiteColor, secondaryColor } = Colors();

  return (
    <FaqWrapper
      onClick={() => {
        handleActiveFAQ(id);
      }}
    >
      <QuestionWrapper>
        <span
          data-aos-once="true"
          data-aos="fade-up"
          style={{
            color: activeFAQID === id ? secondaryColor : whiteColor,
          }}
        >
          {question}
        </span>
        <span
          style={{
            fontSize: "1rem",
            color: "#E9E9ED",
          }}
        >
          {activeFAQID === id ? "-" : "+"}
        </span>
      </QuestionWrapper>
      {activeFAQID === id && (
        <span data-aos-once="true" data-aos="fade-up"  dangerouslySetInnerHTML={{__html:answer}} />
          
      )}
    </FaqWrapper>
  );
};

export default FAQItems;

const FaqWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 30px;
  margin: 20px 0px;
  gap: 10px;
  border: 1px solid #6a6989;
  border-radius: 24px;
  cursor: pointer;
`;

const QuestionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;
